import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { useEstadisticasModel } from '../../../modelos/Estadisticas/modeloEstadisticas'
import React, { useState, useEffect, useMemo } from 'react';
import { formatearPrecio , formatPercent, toYYYYMMDD} from '../../../utils/utils';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { subYears, parseISO } from 'date-fns';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ModuloEstadisticas = () => {
  const {estadisticas,loadingestadisticas,errorestadisticas,cargarEstadisticas,
    estadisticasAnteriores,loadingestadisticasAnteriores,errorestadisticasAnteriores,cargarEstadisticasAnteriores
  } = useEstadisticasModel();
  const {configuracion} =useConfiguracion();

  //ventas y ganancias
  const [ventasData, setVentasData] = useState(null);
  const [gananciasData, setGananciasData] = useState(null);

  //fechas
  const [fechaInicio, setFechaInicio] = useState(() => {
      const hoy = new Date();
      const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      return toYYYYMMDD(primerDia);
    });
  const [fechaFinal, setFechaFinal] = useState(() => {
    const hoy = new Date(); // Obtiene la fecha y hora actual
    return toYYYYMMDD(hoy); // La formatea directamente
  });

  useEffect(() => {
      if (configuracion.nombreEmpresa && fechaInicio && fechaFinal) {
        console.log(`Enviando rango: ${fechaInicio} a ${fechaFinal}`);
        cargarEstadisticas(configuracion.nombreEmpresa, fechaInicio, fechaFinal);

        try{
          const fechaInicioAnterior = toYYYYMMDD(subYears(parseISO(fechaInicio), 1));
          const fechaFinalAnterior = toYYYYMMDD(subYears(parseISO(fechaFinal), 1));

          console.log(`Enviando rango anterior: ${fechaInicioAnterior} a ${fechaFinalAnterior}`);
          cargarEstadisticasAnteriores(configuracion.nombreEmpresa, fechaInicioAnterior, fechaFinalAnterior);

        }catch(error){
          console.error("Error al calcular fechas anteriores:", error);
        }

      }

      // La dependencia ahora incluye las fechas para que se vuelva a ejecutar si las cambias.
    }, [configuracion.nombreEmpresa, fechaInicio, fechaFinal]);

  useEffect(() => {
      // Esta es la clave: Solo se ejecuta si 'estadisticas' y 'graficaData' existen.
      if (estadisticas && estadisticas.graficaData) {
          console.log("Procesando los datos de las gráficas porque 'estadisticas' se actualizó:", estadisticas);

          const labels = estadisticas.graficaData.map(d => d.fecha);

          setVentasData({
              labels,
              datasets: [{
                  label: 'Ventas por Día',
                  data: estadisticas.graficaData.map(d => d.ventas),
                  borderColor: 'rgb(54, 162, 235)',
                  backgroundColor: 'rgba(54, 162, 235, 0.5)',
                  tension: 0.3,
              }],
          });

          setGananciasData({
              labels,
              datasets: [{
                  label: 'Ganancias por Día',
                  data: estadisticas.graficaData.map(d => d.ganancias),
                  borderColor: 'rgb(75, 192, 192)',
                  backgroundColor: 'rgba(75, 192, 192, 0.5)',
                  tension: 0.3,
              }],
          });
      }
  }, [estadisticas]);

  //stats
  // --- NUEVO COMPONENTE REUTILIZABLE PARA TARJETAS DE ESTADÍSTICAS ---
  // Puedes poner esto en el mismo archivo o en uno de utilidades
  const ComparisonBadge = ({ current, previous }) => {
    // No renderizar si no tenemos los números necesarios
    if (typeof previous !== 'number' || typeof current !== 'number') {
      return null;
    }

    // Caso especial: si el valor anterior era 0, cualquier aumento es "Nuevo" o infinito
    if (previous === 0) {
      return (
        <span className="ml-2 text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">
          Nuevo
        </span>
      );
    }

    // Cálculo del porcentaje de cambio
    const percentChange = ((current - previous) / Math.abs(previous)) * 100;
    const isPositive = percentChange >= 0;

    return (
      <span className={`ml-2 text-xs font-semibold px-2 py-0.5 rounded-full ${isPositive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
        {isPositive ? '▲' : '▼'} {percentChange.toFixed(1)}%
      </span>
    );
  };
  // Acepta título, valor, un ícono y clases de color para el texto.
  const StatCard = ({ title, displayValue, icon, colorClass = 'text-gray-900', value, oldValue, formatter = (val) => val }) => (
  <div className="bg-white p-4 rounded-xl shadow-sm flex items-center gap-4 transition-all duration-300 hover:shadow-lg hover:scale-105">
    {/* Contenedor del ícono */}
    <div className="p-3 bg-gray-100 rounded-full">
      {icon}
    </div>
    
    {/* Contenedor del texto */}
    <div>
      <span className="text-sm font-medium text-gray-500">{title}</span>
      <div className="flex items-center">
        <p className={`text-xl font-bold ${colorClass}`}>{displayValue}</p>
        <ComparisonBadge current={value} previous={oldValue} />
      </div>
      
      {/* --- INICIO DEL CAMBIO --- */}
      {/* Esta línea solo aparece si 'oldValue' es un número */}
      {typeof oldValue === 'number' && (
        <p className="text-xs text-gray-500 mt-1">
          Año anterior: {formatter(oldValue)}
        </p>
      )}
      {/* --- FIN DEL CAMBIO --- */}

    </div>
  </div>
);

  // --- ÍCONOS (puedes moverlos a su propio archivo si quieres) ---
  // Usaremos SVGs simples para un look limpio.
  const IconoVentas = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>;
  const IconoDinero = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v.01" /></svg>;
  const IconoCosto = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
  const IconoPorcentaje = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" /></svg>;
  const IconoGanancia = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>;

  
  if (loadingestadisticas && loadingestadisticasAnteriores) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Cargando Estadisticas...</p>
        </div>
      </div>
    );
  }

  if (errorestadisticas && errorestadisticasAnteriores) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Error estadisticas {errorestadisticas}...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen p-4 sm:p-6">
      <div className="max-w-7xl mx-auto">
        
        {/* --- ENCABEZADO Y SELECTOR DE FECHAS --- */}
        <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard de Estadísticas</h1>
            <p className="text-sm text-gray-500 mt-1">Análisis de rendimiento del periodo seleccionado.</p>
          </div>
          <div className="mt-4 sm:mt-0 flex items-center gap-2 bg-white p-2 rounded-lg shadow-sm">
            <input 
                type="date" 
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                className="p-1.5 border border-gray-200 rounded-md text-sm focus:ring-2 focus:ring-blue-500"
            />
            <span className="text-gray-400">-</span>
            <input 
                type="date"
                value={fechaFinal}
                onChange={(e) => setFechaFinal(e.target.value)}
                className="p-1.5 border border-gray-200 rounded-md text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* --- CONTENEDOR PRINCIPAL (2 COLUMNAS) --- */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

          {/* --- COLUMNA IZQUIERDA (GRÁFICAS) --- */}
          <div className="lg:col-span-2 flex flex-col gap-6">
            <div className="bg-white p-4 rounded-xl shadow-sm">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Evolución de Ventas</h3>
              {ventasData ? <Line data={ventasData} options={{ responsive: true }} /> : <p className="text-center text-gray-500 py-10">Cargando...</p>}
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Evolución de Ganancias</h3>
              {gananciasData ? <Line data={gananciasData} options={{ responsive: true }} /> : <p className="text-center text-gray-500 py-10">Cargando...</p>}
            </div>
          </div>

          {/* --- COLUMNA DERECHA (TARJETAS DE ESTADÍSTICAS) --- */}
          <div className="lg:col-span-1 flex flex-col gap-4">
            <h3 className="text-lg font-semibold text-gray-800">Resumen del Periodo</h3>
            
            <StatCard 
              title="Ganancias Reales" 
              displayValue={formatearPrecio(estadisticas?.gananciasReales)} 
              value={estadisticas?.gananciasReales} // El número actual para el cálculo
              oldValue={estadisticasAnteriores?.gananciasReales} // El número anterior para el cálculo
              icon={IconoGanancia}
              colorClass="text-green-600"
            />

            <StatCard 
              title="Dinero en Ventas" 
              displayValue={formatearPrecio(estadisticas?.dineroVentas)} 
              value={estadisticas?.dineroVentas} // El número actual para el cálculo
              oldValue={estadisticasAnteriores?.dineroVentas} // El número anterior para el cálculo
              icon={IconoDinero}
              colorClass="text-green-600"
            />

            <StatCard 
              title="Costos de ventas" 
              displayValue={formatearPrecio(estadisticas?.costoVentas)} 
              value={estadisticas?.costoVentas} // El número actual para el cálculo
              oldValue={estadisticasAnteriores?.costoVentas} // El número anterior para el cálculo
              icon={IconoCosto}
              colorClass="text-green-600"
            />

            <StatCard 
              title="Gastos de empresa" 
              displayValue={formatearPrecio(estadisticas?.costosEmpresa)} 
              value={estadisticas?.costosEmpresa} // El número actual para el cálculo
              oldValue={estadisticasAnteriores?.costosEmpresa} // El número anterior para el cálculo
              icon={IconoCosto}
              colorClass="text-green-600"
            />

            <StatCard 
              title="Total de Costos" 
              displayValue={formatearPrecio(estadisticas?.totalCostos)} 
              value={estadisticas?.totalCostos} // El número actual para el cálculo
              oldValue={estadisticasAnteriores?.totalCostos} // El número anterior para el cálculo
              icon={IconoCosto}
              colorClass="text-green-600"
            />

            <StatCard 
              title="Número de Ventas" 
              displayValue={estadisticas?.numeroVentas} 
              value={estadisticas?.numeroVentas} // El número actual para el cálculo
              oldValue={estadisticasAnteriores?.numeroVentas} // El número anterior para el cálculo
              icon={IconoVentas}
              colorClass="text-green-600"
            />

            <StatCard 
              title="Ganancias reales" 
              displayValue={formatPercent(estadisticas?.gananciasReales/estadisticas?.dineroVentas)} 
              value={estadisticas?.gananciasReales/estadisticas?.dineroVentas} // El número actual para el cálculo
              oldValue={estadisticasAnteriores?.gananciasReales/estadisticasAnteriores?.dineroVentas} // El número anterior para el cálculo
              icon={IconoVentas}
              colorClass="text-green-600"
            />

          </div>
        </div>
      </div>
    </div>
  );

};

export default ModuloEstadisticas
